import { authContainer } from '@/modules/auth/di/container';
import { useImpersonationStore } from './impersonation.store';

/**
 * Busca as roles do alvo da máscara. O `GET /auth/me/perks` sai com o
 * `x-act-as-session-id` e o backend responde pelo alvo, sem rota nova.
 *
 * Mora fora do store porque o repositório já importa o store (para encerrar a
 * máscara no fim da sessão). A resposta que chega depois de trocar ou sair da
 * máscara é descartada: ela é de outro alvo.
 */
export async function loadTargetRoles(): Promise<void> {
  const userId = useImpersonationStore.getState().target?.userId;
  if (!userId) return;
  const isCurrent = () =>
    useImpersonationStore.getState().target?.userId === userId;

  useImpersonationStore.setState({ targetRoles: { status: 'pending' } });
  try {
    const roles = await authContainer.repository.getEffectivePerkKeys();
    if (isCurrent()) {
      useImpersonationStore.setState({
        targetRoles: { status: 'success', roles },
      });
    }
  } catch {
    if (isCurrent()) {
      useImpersonationStore.setState({ targetRoles: { status: 'error' } });
    }
  }
}
